'use client';
import Link from 'next/link';
import NextImage from '@/features/Image';

const LiveSearchList = ({ suggestions = [], clearSuggestions }: any) => {
  const emphasizeMatchWord = (text: string) => {
    return text;
  };

  const formatPrice = (price: number) => {
    return Number(price).toLocaleString('en-BD', { minimumFractionDigits: 2 });
  };

  if (!suggestions.length) return null;

  return (
    <div className="search">
      {suggestions.map((product: any) => (
        <Link
          href={`/product/${product.slug}`}
          key={product.id}
          className="search__item"
          onClick={() => clearSuggestions()}
        >
          <div className="search__media">
            <NextImage
              src={product.small_pictures?.[0]?.url || '/placeholder.jpg'}
              alt={'Product image'}
              width={50}
              height={50}
              className="search__image"
            />
            <div
              className="search__name"
              dangerouslySetInnerHTML={{
                __html: emphasizeMatchWord(product.name),
              }}
            />
          </div>
          <div className="search__price">
            <div className="search__price-value">
              {product.sale_price === product.price ? (
                <>৳{formatPrice(product.sale_price)}</>
              ) : (
                <>
                  <span>৳{formatPrice(product.sale_price)}</span>{' '}
                  <del className="search__price-old ms-2">
                    ৳{formatPrice(product.price)}
                  </del>
                </>
              )}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default LiveSearchList;
